module.exports = __webpack_public_path__ + "static/media/aggiungi.60cd3cb2.png";